<template>
    <div
        :style="{
            color: player.textColor,
            borderColor: player.borderColor,
        }"
        class="flex flex-col sm:flex-row px-4 py-6 sm:px-12 sm:py-12 items-center justify-between text-sm md:text-base border-t"
    >
        <div class="mb-2 sm:mb-0">
            <cUtilsEdit @edit="goToLayoutField('playerFooterText')">
                <p>© {{ new Date().getFullYear() + " " + player.footerText }}</p>
            </cUtilsEdit>
        </div>

        <div class="text-center">
            <div class="mr-6 inline-block">
                <cUtilsEdit @edit="goToLayoutField('playerFooterPolicy')">
                    <a
                        target="_blank"
                        :href="player.footerPolicy"
                        @click.prevent="goToLink(player.footerPolicy)"
                        class="inline-block hover:underline"
                    >
                        {{ $t("r_player.privacy_policy") }}
                    </a>
                </cUtilsEdit>
            </div>
            <div class="inline-block">
                <cUtilsEdit @edit="goToLayoutField('playerFooterTerms')">
                    <a
                        target="_blank"
                        :href="player.footerTerms"
                        @click.prevent="goToLink(player.footerTerms)"
                        class="inline-block hover:underline"
                    >
                        {{ $t("r_player.terms") }}
                    </a>
                </cUtilsEdit>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { usePlayerGoTo } from "@/views/tools/player/utils/usePlayerGoTo";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "PlayerFooter",
    components: { cUtilsEdit },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToLayoutField } = usePlayerGoTo();
        return {
            goToLayoutField,
            goToLink,
        };
    },
    computed: {
        ...mapState("player/view", ["player"]),
    },
};
</script>
